var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusArrivedFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5C12.8285 6.5 13.5 5.82845 13.5 5C13.5 4.17158 12.8285 3.5 12 3.5C11.1715 3.5 10.5 4.17158 10.5 5C10.5 5.82845 11.1715 6.5 12 6.5Z",
    fill: "#04B7B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C11.4477 4 11 4.44771 11 5C11 5.5523 11.4477 6 12 6C12.5523 6 13 5.5523 13 5C13 4.44771 12.5523 4 12 4ZM10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5C14 6.10455 13.1046 7 12 7C10.8954 7 10 6.10455 10 5Z",
    fill: "#04B7B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.65C15 10.8145 14.6839 10.0133 14.1213 9.4226C13.5587 8.83185 12.7957 8.5 12 8.5C11.2043 8.5 10.4413 8.83185 9.8787 9.4226C9.31605 10.0133 9 10.8145 9 11.65V13H10.2857L10.7143 17.5H13.2857L13.7143 13H15V11.65Z",
    fill: "#04B7B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5166 9.0778C10.1709 8.3908 11.0637 8 12 8C12.9363 8 13.8291 8.3908 14.4834 9.0778C15.1369 9.76395 15.5 10.6896 15.5 11.65V13C15.5 13.2761 15.2761 13.5 15 13.5H14.169L13.7835 17.5474C13.759 17.804 13.5435 18 13.2857 18H10.7143C10.4565 18 10.241 17.804 10.2165 17.5474L9.83105 13.5H9C8.72385 13.5 8.5 13.2761 8.5 13V11.65C8.5 10.6896 8.8631 9.76395 9.5166 9.0778ZM12 9C11.345 9 10.7117 9.27295 10.2408 9.76745C9.76905 10.2628 9.5 10.9395 9.5 11.65V12.5H10.2857C10.5435 12.5 10.759 12.696 10.7835 12.9526L11.169 17H12.831L13.2165 12.9526C13.241 12.696 13.4565 12.5 13.7143 12.5H14.5V11.65C14.5 10.9395 14.2309 10.2628 13.7592 9.76745C13.2883 9.27295 12.655 9 12 9Z",
    fill: "#04B7B1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7V11H3V7H4Z",
    fill: "#04B7B1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8.5H7V9.5H3V8.5Z",
    fill: "#04B7B1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 7V11H20V7H21Z",
    fill: "#04B7B1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8.5H21V9.5H17V8.5Z",
    fill: "#04B7B1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.06585 14.3435C7.1522 14.6058 7.00955 14.8884 6.74725 14.9748C5.83795 15.2742 5.12835 15.6397 4.65628 16.0303C4.1817 16.423 4 16.7931 4 17.1129C4 17.398 4.14297 17.7207 4.51084 18.0673C4.87968 18.4148 5.44035 18.7507 6.1747 19.0433C7.6406 19.6275 9.69995 19.9999 12 19.9999C14.3001 19.9999 16.3594 19.6275 17.8253 19.0433C18.5597 18.7507 19.1203 18.4148 19.4891 18.0673C19.857 17.7207 20 17.398 20 17.1129C20 16.7931 19.8183 16.423 19.3437 16.0303C18.8717 15.6397 18.1621 15.2742 17.2528 14.9748C16.9905 14.8884 16.8478 14.6058 16.9342 14.3435C17.0205 14.0812 17.3032 13.9386 17.5655 14.025C18.5439 14.3471 19.3797 14.7622 19.9812 15.2599C20.5801 15.7554 21 16.3811 21 17.1129C21 17.7631 20.6673 18.3313 20.1749 18.7952C19.6835 19.2581 18.9993 19.652 18.1954 19.9723C16.5849 20.614 14.3943 20.9999 12 20.9999C9.6057 20.9999 7.41505 20.614 5.80455 19.9723C5.0007 19.652 4.31655 19.2581 3.82513 18.7952C3.33274 18.3313 3 17.7631 3 17.1129C3 16.3811 3.41987 15.7554 4.0188 15.2599C4.62024 14.7622 5.4561 14.3471 6.43455 14.025C6.69685 13.9386 6.9795 14.0812 7.06585 14.3435Z",
    fill: "#04B7B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusArrivedFill);
export default __webpack_public_path__ + "static/media/StatusArrivedFill.2848e8392e1aca66a3fddec488b97af5.svg";
export { ForwardRef as ReactComponent };